import { OnInit } from '@angular/core';
import { SearchService } from './shared/search.service';
var SearchComponent = /** @class */ (function () {
    function SearchComponent(searchService) {
        this.searchService = searchService;
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchService.getSearchbarTabindex().subscribe(function (val) {
            _this.initialTabindex = val;
        });
    };
    SearchComponent.prototype.onSearchTermChange = function (evt) {
        var _this = this;
        setTimeout(function () {
            _this.searchTerm = evt.searchTerm;
            _this.itemCount = evt.itemCount;
        });
    };
    return SearchComponent;
}());
export { SearchComponent };
